import { QuizQuestionJson } from '~/monolith-api';
import { Box, Image, Text } from '@chakra-ui/react';

type ImageQuestionProps = {
   question: QuizQuestionJson;
};

const Media = ({ question }: ImageQuestionProps) => {
   if (question.contentMode === 'video' || question.mediaType === 'GuideVideoObject') {
      return (
         <Box m="auto" p="5px">
            <video controls aria-label={question.altText ?? question.name}>
               <source src={question.imageLink} />
            </video>
         </Box>
      );
   }
   return (
      <Image src={question.imageLink} alt={question.altText ?? question.name} m="auto" pt="5px" />
   );
};

export const ImageQuestion = ({ question }: ImageQuestionProps) => {
   return (
      <Box backgroundColor="var(--chakra-colors-gray-100)" maxW="600px">
         <Media question={question} />
         <Text p="20px">{question.caption}</Text>
      </Box>
   );
};
